export const EVENT_CONSTANTS = {
  TASK_COMPLETE_REFETCH_SUMMARY: 'taskCompleteRefetchSummaryEvent',
  DISABLE_FOCUS_TRAP: 'DISABLE_FOCUS_TRAP',
  ENABLE_FOCUS_TRAP: 'ENABLE_FOCUS_TRAP',
}
